// extracted by mini-css-extract-plugin
export default {"InlineLink":"InlineLink-module--InlineLink--eXQM5"};